import React, { useEffect, useRef, useState } from "react";
import { INITIAL_CONTACT_FILTER_STATE } from "../Common/Constants";

const ContactGroupFilterModal = ({ closeFilter, filterData, onPressApply }) => {
  const modalRef = useRef(null);

  const [contactGroupFilterData, setContactGroupFilterData] =
    useState(filterData);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeFilter();
    }
  };

  const onPressApplyFilter = () => {
    onPressApply({
      ...contactGroupFilterData,
      isActive: contactGroupFilterData?.isActive || false,
    });
  };

  const onPressClearFilter = () => {
    onPressApply(INITIAL_CONTACT_FILTER_STATE);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div className="filter__dropdown" ref={modalRef}>
      <div className="filter__dropdown__body">
        <h3 className="title">Filter By</h3>
        <div className="form__Field">
          <label htmlFor="active" className="form__label">
            Status
          </label>
          <div className="form__switchBtn">
            <div className="form__switchBtn__option">
              <div className="switchBtn">
                <input
                  type="checkbox"
                  className="toggle"
                  id="toggle-mfa"
                  checked={contactGroupFilterData.isActive}
                  onChange={(e) => {
                    setContactGroupFilterData((prev) => ({
                      ...prev,
                      isActive: e.target.checked,
                    }));
                  }}
                />
                <label for="toggle-mfa">
                  <span className="on">ON</span>
                  <span className="off">OFF</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="filter__dropdown__footer">
        <div className="btn__group">
          <button className="btn btn__white" onClick={onPressClearFilter}>
            Clear
          </button>
          <button className="btn btn__primary" onClick={onPressApplyFilter}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactGroupFilterModal;
